<template>
  <div style="margin: 10px 40px 0px">
    <el-form style="margin-right: 30px" :model="editOrgForm" :rules="editOrgRules" ref="editOrgForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="组织名称" prop="name">
        <el-input v-model="editOrgForm.name" placeholder="请输入组织名称"></el-input>
      </el-form-item>
      <el-form-item label="上级组织" prop="orgpid">
        <el-cascader v-fixZoom :disabled="true" style="width: 100%" :options="orgOptions"
          v-model="editOrgForm.orgpid" :filterable="true" placeholder="请选择上级组织"
          :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}" ref="orgOptions">
        </el-cascader>
      </el-form-item>
    </el-form>
<!--    <div style="text-align: center">-->
<!--      <el-button @click="closeEdit()">取 消</el-button>-->
<!--      <el-button type="primary" @click="submitEditOrg('editOrgForm')">确 定</el-button>-->
<!--    </div>-->
    <div style="margin-top: 30px">
      <el-row style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitEditOrg('editOrgForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 30px"></div>
  </div>
</template>

<script>
import {updateorg} from '../../../api/organizer'

export default {
  name: 'orgEdit',
  model: {
    prop: 'editShow',
    event: 'change'
  },
  props: {
    orgEditRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      orgOptions: [],
      editOrgForm: {
        id: '',
        name: '',
        level: '',
        orgpid: ''
      },
      editOrgRules: {
        name: [
          { required: true, message: '请输入组织名称', trigger: 'blur' }
        ],
        orgpid: [
          { required: true, message: '请选择上级组织', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.getEidtForm()
    this.orgOptions = this.orgEditRow.orgTree
  },
  mounted () {
  },
  methods: {
    getEidtForm () {
      this.editOrgForm.id = this.orgEditRow.row.id
      this.editOrgForm.name = this.orgEditRow.row.name
      this.editOrgForm.level = this.orgEditRow.row.level
      this.editOrgForm.orgpid = this.orgEditRow.row.orgpid
    },
    submitEditOrg (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateorg(this.editOrgForm).then(res => {
            this.$notify({
              title: '成功',
              message: '成功更新组织',
              type: 'success',
              duration: 2000
            })
            this.golobleObject.updateTableOrg()
            this.$emit('change', false)
          }).catch(() => {
            this.$notify.error({
              title: '失败',
              message: '更新组织失败'
            })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeEdit () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/orgEdit.vue